import { render } from "./DeleteRoute.vue?vue&type=template&id=689c8651"
import script from "./DeleteRoute.vue?vue&type=script&lang=js"
export * from "./DeleteRoute.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/html/miw-alpha/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__